import React, {lazy, Suspense} from 'react';
import ShimmerComponent from '../../common/shimmerComponent/shimmerComponent';

import './voiceMsgUploadingLoader.css';

const SoundWaveIcon = lazy(
  () => import('../../../assets/svgComponents/SoundWaveIcon'),
);

const VoiceMsgUploadingLoader = (largeUI = false) => {
  return (
    <div className="et-voice-msg-loader-container">
      {/* Left: Circular shimmer with spinner */}
      <div className="et-voice-msg-loader-left">
        <div className="et-voice-msg-loader-left-shimmer">
          <ShimmerComponent />
        </div>
      </div>

      {/* Right: Shimmer with soundwave */}
      <div className="et-voice-msg-loader-right">
        <div className="et-voice-msg-loader-right-shimmer">
          <ShimmerComponent />
        </div>
        <div className="et-voice-msg-loader-soundwave">
          <Suspense fallback={<></>}>
            <SoundWaveIcon
              width={largeUI === true ? 999 : 188}
              fillColor={'#A8C0FA6F'}
            />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default VoiceMsgUploadingLoader;
